import type {Context} from '../types';

export default function (context: Context) {
  const {jsonNode} = context.node;

  const isDynamoWrapper =
    jsonNode.type === 'DynamoWrapper' || jsonNode.data?.dyn?.type === 'wrapper';

  const dataDynQueryFilterFor = jsonNode.data?.dyn?.query?.filterFor;
  const dataDynQueryFields = jsonNode.data?.dyn?.query?.fields;

  const hasValidFilterFor =
    dataDynQueryFilterFor != null && typeof dataDynQueryFilterFor === 'string';
  const hasValidFields =
    dataDynQueryFields != null && Array.isArray(dataDynQueryFields);

  const isNeeded = isDynamoWrapper && (hasValidFilterFor || hasValidFields);

  return {
    needed: isNeeded,
    logData: {
      msg: 'Dynamo Wrapper fields and filterFor migration',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      if (dataDynQueryFilterFor == null && dataDynQueryFields == null) {
        return;
      }
      if (!jsonNode.data) {
        jsonNode.data = {};
      }
      if (!jsonNode.data.dyn) {
        jsonNode.data.dyn = {};
      }
      if (!jsonNode.data.dyn.query) {
        jsonNode.data.dyn.query = {};
      }
      jsonNode.data.dyn.query.filter = {};
      // Set the fields and filterFor to the filter
      if (dataDynQueryFields) {
        jsonNode.data.dyn.query.filter.fields = dataDynQueryFields;
        delete jsonNode.data.dyn.query.fields; // eslint-disable-line webflow/no-delete
      }
      if (dataDynQueryFilterFor) {
        jsonNode.data.dyn.query.filter.filterFor = dataDynQueryFilterFor;
        delete jsonNode.data.dyn.query.filterFor; // eslint-disable-line webflow/no-delete
      }
    },
  };
}
